const TRUE_VALUES = new Set(['true', '1', 'yes', 'on', 'enable', 'enabled']);
const FALSE_VALUES = new Set(['false', '0', 'no', 'off', 'disable', 'disabled']);

/**
 * 文字列として提供される環境変数の値を真偽値へ変換する
 *
 * @param value 環境変数の値
 * @param defaultValue 変換できない場合に採用するデフォルト値
 */
export function resolveBooleanFlag(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined || value === null) {
    return defaultValue;
  }

  const normalized = value.toString().trim().toLowerCase();
  if (normalized.length === 0) {
    return defaultValue;
  }

  if (TRUE_VALUES.has(normalized)) {
    return true;
  }

  if (FALSE_VALUES.has(normalized)) {
    return false;
  }

  return defaultValue;
}
